export default __webpack_public_path__ + "static/media/35-magnum.a6d578f7.jpg";